// Per-tab, short-lived results; never persist account-specific comparisons.
export function createComparisonCache({ ttl = 5 * 60 * 1000, maxEntries = 12, now = Date.now } = {}) {
  const entries = new Map();
  return async function get(key, load, { force = false } = {}) {
    const existing = entries.get(key);
    if (!force && existing && existing.expires > now()) return existing.promise;
    const entry = { expires: now() + ttl };
    entry.promise = Promise.resolve().then(load).then(results => {
      // A failure must remain retryable, not appear as a cached empty device.
      if (!results.length || results.some(row => !row.success)) {
        if (entries.get(key) === entry) entries.delete(key);
      } else entry.expires = now() + ttl;
      return results;
    }, error => {
      if (entries.get(key) === entry) entries.delete(key);
      throw error;
    });
    entries.delete(key);
    entries.set(key, entry);
    while (entries.size > maxEntries) entries.delete(entries.keys().next().value);
    return entry.promise;
  };
}
